import React, { useState, useEffect } from 'react';
import anime from 'animejs';

const NavigateButton = () => {
  const [exchangeData, setExchangeData] = useState(null);


  useEffect(() => {
    const fetchRates = async () => {
      try {
        const response = await fetch("https://api.genelpara.com/json/?list=doviz&sembol=USD,EUR");
        const json = await response.json();
        if (json.success) {
          setExchangeData(json.data);
        }
      } catch (error) {
        console.error("Döviz verisi alınamadı:", error);
      }
    };

    fetchRates();
    const interval = setInterval(fetchRates, 60000); 
    
    anime({
      targets: '.nav-reveal',
      opacity: [0, 1],
      translateY: [30, 0],
      delay: anime.stagger(200),
      duration: 1200,
      easing: 'easeOutExpo'
    });

    return () => clearInterval(interval);
  }, []);

  const handleClick = () => {
    window.location.href = 'https://www.kiyiemniyeti.gov.tr/lighthouse_and_salvage_fee_calculator';
  };

  return (
 
    <main className="flex flex-col lg:flex-row w-full min-h-[70vh] bg-[#fdfcfb] font-sans selection:bg-[#c4a47c] overflow-hidden">

      <section className="w-full lg:w-3/5 flex flex-col justify-center px-8 md:px-16 lg:px-24 py-16 bg-white relative">
       
        <div className="absolute -top-24 -left-24 w-80 h-80 bg-[#c4a47c]/5 rounded-full blur-3xl opacity-60 pointer-events-none"></div>
        
        <div className="nav-reveal opacity-0 relative z-10">
          <header className="mb-8">
            <div className="flex items-center space-x-4 mb-4">
              <div className="h-[1px] w-10 bg-[#c4a47c]"></div>
              <span className="text-[#c4a47c] text-[10px] font-black uppercase tracking-[0.5em]"></span>
            </div>
          
            <h1 className="text-4xl md:text-6xl font-black text-[#0a111f] leading-tight mb-4 uppercase italic tracking-tighter">
              Lighthouse & <br/>
              <span className="text-[#c4a47c]">Salvage Fees</span>
            </h1>
          </header>

         
          <p className="text-base md:text-lg  text-slate-500 mb-10 max-w-lg leading-loose font-light italic border-l-2 border-[#c4a47c]/20 pl-6 relative">
            
            Reckoner For Lighthouses And Salvage Remuneration
Click below to calculate the lighthouse and salvage fees.
          </p>

          <button
            onClick={handleClick}
          
            className="group relative inline-flex items-center justify-center px-10 py-4 bg-[#0f172a] text-white font-black uppercase text-[11px] tracking-[0.4em] rounded-full shadow-2xl hover:bg-[#c4a47c] transition-all duration-500 transform hover:-translate-y-1"
          >
            <span>Go to Reckoner</span>
            <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 ml-4 group-hover:translate-x-2 transition-transform duration-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </button>
        </div>
      </section>

  
      <section className="w-full lg:w-2/5 flex items-center justify-start p-8 md:p-12 bg-[#f4f1ea] relative group">
        <div className="nav-reveal opacity-0 w-full max-w-sm relative transition-transform duration-700 group-hover:scale-[1.02]">
          
          <div className="bg-white rounded-[2rem] p-8 shadow-[0_40px_80px_rgba(0,0,0,0.06)] border border-white relative z-10">
            <div className="text-center mb-6 border-b border-gray-100 pb-4">
        
              <h2 className="text-[14px] font-black text-[#0a111f] tracking-[0.6em] uppercase mb-2">Currency Rates</h2>
              <div className="h-[2px] w-8 bg-[#c4a47c] mx-auto"></div>
            </div>

            <div className="min-h-[140px] flex items-center justify-center">
              {exchangeData ? (
                <div className="w-full space-y-6">
                  
                  <div className="flex justify-between items-center">
                    <div>
                      <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">USD / TRY</p>
                      <p className="text-2xl font-black text-[#0a111f] tabular-nums">{exchangeData.USD.satis}</p>
                    </div>
                    <span className={`text-[11px] font-bold px-2 py-1 rounded-md ${exchangeData.USD.yon === 'moneyUp' ? 'text-green-600 bg-green-50' : 'text-red-600 bg-red-50'}`}>
                      {exchangeData.USD.yon === 'moneyUp' ? '▲' : '▼'} {exchangeData.USD.oran}%
                    </span>
                  </div>

                  {/* EUR */}
                  <div className="flex justify-between items-center">
                    <div>
                      <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">EUR / TRY</p>
                      <p className="text-2xl font-black text-[#0a111f] tabular-nums">{exchangeData.EUR.satis}</p>
                    </div>
                    <span className={`text-[11px] font-bold px-2 py-1 rounded-md ${exchangeData.EUR.yon === 'moneyUp' ? 'text-green-600 bg-green-50' : 'text-red-600 bg-red-50'}`}>
                      {exchangeData.EUR.yon === 'moneyUp' ? '▲' : '▼'} {exchangeData.EUR.oran}%
                    </span>
                  </div>
                </div>
              ) : (
            
                <div className="w-full h-32 flex items-center justify-center relative overflow-hidden bg-gray-50 rounded-2xl animate-pulse">
                   <div className="w-1/2 h-4 bg-gray-100 rounded-full"></div>
                </div>
              )}
            </div>
            
            <p className="mt-8 text-center text-[9px] text-gray-300 font-medium uppercase tracking-[0.3em]">
             
            </p>
          </div>
          
       
          <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-[#c4a47c]/10 rounded-full -z-0 blur-xl pointer-events-none"></div>
        </div>
      </section>
    </main>
  );
};

export default NavigateButton;